import { CORE_MENTEE_MODULE_STATUSES } from './coreMenteModuleStatuses';
import { MENTEE_MODULE_STATUSES } from './menteeModuleStatuses';

export const CORE_MENTEE_MODULE_STATUS_OPTIONS = Object.values(
  MENTEE_MODULE_STATUSES
)
  .filter((status) => CORE_MENTEE_MODULE_STATUSES.includes(status))
  .map((status) => ({
    label: status,
    value: status,
  }));
